import * as Html from "./Html.ts";

export type ProgressBar = {
  progress : (percent :number)=>void;
  close : ()=>void;
}

export const none :ProgressBar = {
  progress:(percent :number)=>{},
  close:()=>{}
}

export const standard :ProgressBar & {frontDiv:HTMLElement,showTimeout:number} = {
  frontDiv : document.querySelector<HTMLElement>(".fw-loading"),
  showTimeout : undefined,
  progress(percent :number){
    clearTimeout(this.showTimeout);
    //we show it
    this.frontDiv.style.display = 'flex';
    this.showTimeout = setTimeout(()=>{
      this.frontDiv.style.opacity = '1';
    },200);

  },
  close(){
    clearTimeout(this.showTimeout);
    this.frontDiv.style.display = 'none';
    this.frontDiv.style.opacity = '0';
    const p = this.frontDiv.querySelector('p');
    if (p) p.innerHTML = '';
  }
};


export function auto(){
  return Html.isRunningClick()?standard:none;
}